import React from 'react';
import ReactDOM from 'react-dom';
import styles from './ProjectPopup.module.css';

function ProjectPopup({ project, onClose }) {
  if (!project) {
    return null;
  }

  const handleOverlayClick = () => {
    onClose();
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return ReactDOM.createPortal(
    <div className={styles.popupOverlay} onClick={handleOverlayClick}>
      <div className={styles.popupContent} onClick={handleContentClick}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <h2>{project.title}</h2>
        <div className={styles.imageContainer}>
          <img src={project.imageUrl} alt={project.title} className={styles.projectImage} />
        </div>
        <p className={styles.projectDescription}>{project.description}</p>
        <div className={styles.projectLinks}>
          {project.githubUrl && (
            <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className={styles.link}>
              GitHub
            </a>
          )}
          {project.liveUrl && (
            <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className={styles.link}>
              Have a look!
            </a>
          )}
        </div>
      </div>
    </div>,
    document.getElementById('popup-root')
  );
}

export default ProjectPopup;
